import { Box } from "@mui/material"
import React, { useContext } from "react"
import { BSBuildingContext } from "../../../../components/context/BSBuildingContext"
import { BSBuildingLevelContainer } from "./components/BSBuildingLevelContainer"
import { BSBuildingPrincipalUsageForm } from "./components/BSBuildingPrincipalUsageForm"
import { BSLevelFormContext } from "../../context/BSLevelFormContext"

export function BSBuildingZoneContainer(): React.JSX.Element {
  const { selectedBSBuilding } = useContext(BSBuildingContext)
  const { groupLevelSuperstructureListForm, groupLevelInfrastructureListForm } = useContext(BSLevelFormContext)

  return (
    <>
      {/* V0 Temporary component in order to enable calculation with main usage */}
      {/* When multi usage, it will be affected according to level */}
      <Box minWidth="70%">
        <BSBuildingPrincipalUsageForm />
      </Box>

      {/* For now the 3 sections have titles because product owner don't know if use accordion or control panel */}
      {!selectedBSBuilding?.bim && (
        <Box display="flex" flexDirection="column" alignItems="center" gap={3}>
          <BSBuildingLevelContainer groupLevelList={groupLevelSuperstructureListForm} isSuperstructure />

          <BSBuildingLevelContainer groupLevelList={groupLevelInfrastructureListForm} />
        </Box>
      )}
    </>
  )
}
